import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import { Button } from '../components/ui/button';
import { faqs } from '../data/mock';

export const FAQ = ({ onBookNow }) => {
  return (
    <div className="min-h-screen pt-24 pb-12">
      {/* Hero */}
      <section className="py-20 bg-gradient-to-br from-page via-card to-page">
        <div className="container mx-auto px-6 text-center">
          <h1 className="heading-1 text-6xl md:text-7xl lg:text-8xl font-black text-primary uppercase mb-6 leading-tight">
            FAQ
          </h1>
          <p className="body-large text-secondary max-w-3xl mx-auto">
            Got questions? We've got answers. Everything you need to know before you break in.
          </p>
        </div>
      </section>

      {/* FAQs */}
      <section className="py-16">
        <div className="container mx-auto px-6 max-w-4xl">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-card border border-medium rounded-2xl px-6 overflow-hidden"
              >
                <AccordionTrigger className="text-left hover:no-underline py-6">
                  <span className="heading-5 text-primary font-bold uppercase">{faq.question}</span>
                </AccordionTrigger>
                <AccordionContent className="pb-6">
                  <p className="body-small text-secondary leading-relaxed">{faq.answer}</p>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          {/* Still Have Questions */}
          <div className="bg-page border border-medium rounded-2xl p-12 text-center mt-12">
            <h2 className="heading-3 text-4xl font-black text-primary uppercase mb-6">Still Have Questions?</h2>
            <p className="body-medium text-secondary max-w-2xl mx-auto mb-8">
              Can't find what you're looking for? Give us a call or send us a message. We're happy to help!
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button onClick={() => window.location.href = '/contact'} className="btn-primary text-lg px-8 py-6">
                Contact Us
              </Button>
              <Button onClick={onBookNow} className="btn-secondary text-lg px-8 py-6">
                Book Now
              </Button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};